import { render, staticRenderFns } from "./DailyOrders.vue?vue&type=template&id=399bf5b8&"
import script from "./DailyOrders.vue?vue&type=script&lang=js&"
export * from "./DailyOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports